import getConfig from 'next/config'

import ButtonBlack from '../../../../components/ui/button/_color/_black'
import { useTranslation } from '../../../../utils/use-translation'

import styles from './styles.module.scss'

const { publicRuntimeConfig } = getConfig()

export function UnlockedVipStatus() {
  const { t } = useTranslation()
  const link = process.env.NEXT_PUBLIC_VIP_ACTIVATE_LINK ?? publicRuntimeConfig.VIP_ACTIVATE_LINK

  return (
    <div className={styles.vipStatus}>
      <div className={styles.main}>
        <h2>{t('unlocked_vip_status_title')}</h2>
        <div className={styles.content}>
          <p>{t('unlocked_vip_status_text')}</p>
          <a href={link} target="_blank" rel="noreferrer">
            <ButtonBlack className={styles.btn}>{t('activate_now')}</ButtonBlack>
          </a>
        </div>
      </div>
    </div>
  )
}
